import React from 'react';
import css from './AppointmentReminders.module.css';
import {
  H3,
  Paragraph,
  StackedColumn,
  StackedColumnSpacing,
} from '../../../core';
import {
  ContactInfoDetails,
  ReviewAndSubmitDetails,
} from '../../../api/models';
import { PhoneUtility } from '@mchs/web-core';

interface AppointmentRemindersProps {
  contactInfoDetails?: ContactInfoDetails;
  reviewAndSubmitDetails?: ReviewAndSubmitDetails;
}

const AppointmentReminders: React.FC<AppointmentRemindersProps> = (
  props: AppointmentRemindersProps
) => {
  const getReminderString = (): string => {
    // We may go back to having Text and Email separate
    // currently we will be sending both
    return `Text message (SMS) to ${
      props.contactInfoDetails?.patientContactDetails.mobileNumber &&
      props.contactInfoDetails?.patientContactDetails.mobileNumber.length > 0
        ? PhoneUtility.formatPhoneNumber(
            props.contactInfoDetails?.patientContactDetails.mobileNumber
          )
        : PhoneUtility.formatPhoneNumber(
            props.contactInfoDetails?.patientContactDetails.phoneNumber
          )
    }\nEmail to ${
      props.contactInfoDetails?.patientContactDetails.emailAddress
    }`;

    // if (props.reviewAndSubmitDetails?.reminderOption === ReminderOption.Text) {
    //   return `Text message (SMS) to ${
    //     props.contactInfoDetails?.patientContactDetails.mobileNumber &&
    //     props.contactInfoDetails?.patientContactDetails.mobileNumber.length > 0
    //       ? PhoneUtility.formatPhoneNumber(props.contactInfoDetails?.patientContactDetails.mobileNumber)
    //       : PhoneUtility.formatPhoneNumber(props.contactInfoDetails?.patientContactDetails.phoneNumber)
    //   }`;
    // }

    // if (props.reviewAndSubmitDetails?.reminderOption === ReminderOption.Email) {
    //   return `Email to ${props.contactInfoDetails?.patientContactDetails.emailAddress}`;
    // }

    //return props.reviewAndSubmitDetails?.reminderOption ?? '';
  };

  return (
    <StackedColumn spacing={StackedColumnSpacing.NoGap}>
      <H3 text="APPOINTMENT REMINDERS" />
      <Paragraph className={css.preformatted} text={getReminderString()} />
    </StackedColumn>
  );
};

export default AppointmentReminders;
